import { useTranslator } from '@Localization';
import { ReactElement } from 'react';
import { IProjectActivity, IProjectActivityRename } from '../../projectDetailsActivities.models';

export const RenameActivity = ({ values }: IProjectActivity<IProjectActivityRename>): ReactElement => {
  const { t } = useTranslator();
  return (
    <div>
      {t('activity_description_Rename')}
      <b>{values.name}</b>.
    </div>
  );
};
